import * as t from 'io-ts';

export const BaseEntityType = t.interface({
    id: t.string,
    name: t.union([t.string, t.null, t.undefined]),
});

export interface BaseEntityDTO extends t.TypeOf<typeof BaseEntityType> {}

export class BaseEntity {
    id: string;
    name: string | null;

    constructor(params: BaseEntityDTO) {
        this.id = params.id;
        this.name = params.name ?? null;
    }
}
